"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Iris = void 0;
// TODO check eslint rule
/* eslint-disable no-console */
const lodash_1 = require("lodash");
const pkg_cruise_api_endpoint_1 = require("pkg-cruise-api-endpoint");
const client_1 = require("../config/client");
const orca_1 = require("./orca");
const unicorn_1 = require("./unicorn");
const expandCategories = (categories) => {
    const verboseCategories = {};
    (0, lodash_1.forEach)(categories, (value, key) => {
        verboseCategories[key] = {};
        verboseCategories[key].amount = value.p;
        if (value.m) {
            verboseCategories[key].mandatoryFlight = value.m;
        }
        if (value.s) {
            verboseCategories[key].surcharges = (0, lodash_1.map)(value.s, (sur) => {
                return { amount: sur.p, type: sur.t };
            });
        }
    });
    return verboseCategories;
};
const expandFlightPrices = (flightPrices) => {
    const verboseFlightPrices = {};
    (0, lodash_1.forEach)(flightPrices, (value, key) => {
        verboseFlightPrices[key] = expandFlightDirections(value);
    });
    return verboseFlightPrices;
};
const expandFlightDirections = (flightDirections) => {
    const verboseFlightDirections = {};
    (0, lodash_1.forEach)(flightDirections, (value, key) => {
        verboseFlightDirections[key] = { amount: value.p };
        if (value.c) {
            verboseFlightDirections[key].availableForCategories = value.c;
        }
    });
    return verboseFlightDirections;
};
const transform = (routes) => {
    routes = (0, lodash_1.map)(routes, (route) => {
        return {
            name: route.n,
            duration: route.d,
            startHabour: route.b,
            endHabour: route.e,
            regionIDs: route.r,
            routeMap: `https://d1ozq1nmb5vv1n.cloudfront.net/fileadmin/user_upload/dam/${route.m}`,
            portImages: (0, lodash_1.map)(route.i, (image) => {
                return `https://carol.cruise-api.aida.de/${image}`;
            }),
            cruises: (0, lodash_1.map)(route.c, (cruise) => {
                const cruisePrices = {};
                for (const priceKey in cruise.p) {
                    if (cruise.p.hasOwnProperty(priceKey)) {
                        cruisePrices[priceKey] = (0, lodash_1.map)(cruise.p[priceKey], (price) => {
                            return {
                                amount: price.a,
                                priceModel: price.p,
                                flight: price.f,
                                surcharges: (0, lodash_1.map)(price.s, (surcharge) => {
                                    return {
                                        type: surcharge.t,
                                        amount: surcharge.a,
                                    };
                                }),
                            };
                        });
                    }
                }
                return {
                    cruiseID: cruise.i,
                    routeCode: cruise.r,
                    start: cruise.b,
                    end: cruise.e,
                    ship: cruise.s,
                    airports: cruise.a,
                    prices: cruisePrices,
                    promoAirports: cruise.w,
                };
            }),
        };
    });
    return routes;
};
const getPriceModels = (priceModels) => {
    if ((0, lodash_1.isArray)(priceModels)) {
        return priceModels.join(',');
    }
    if ((0, lodash_1.isNil)(priceModels)) {
        return 'VARIO';
    }
    return priceModels;
};
const getItineraries = (itineraries) => {
    if ((0, lodash_1.isArray)(itineraries)) {
        return itineraries.join(',');
    }
    return itineraries;
};
class IrisClient extends pkg_cruise_api_endpoint_1.Endpoint {
    constructor() {
        super(pkg_cruise_api_endpoint_1.stage, client_1.endpointMapping);
        this.unicornClient = new unicorn_1.UnicornClient();
        this.orcaClient = new orca_1.ORCAClient();
    }
    booking(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                bookingID: opts.bookingID,
            };
            const pathTemplate = '/bookings/{bookingID}';
            const query = {
                birthDate: opts.birthDate,
                lastName: opts.lastName,
                firstName: opts.firstName,
                matchingQualifiers: opts.matchingQualifiers,
            };
            return this.invokeNoCacheGET(params, pathTemplate, query);
        });
    }
    verificationToken(bookingID) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                bookingID,
            };
            const pathTemplate = '/bookings/{bookingID}/verification';
            const query = {};
            const result = yield this.invokePermanentGET(params, pathTemplate, query);
            return result ? result.token : '';
        });
    }
    // get cabin descripion and availability
    cabin(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                cruiseID: opts.cruiseID,
                id: opts.id,
            };
            let pathTemplate = '/cruises/{cruiseID}/cabins/{id}';
            if (opts.configCode !== undefined) {
                params.configCode = opts.configCode;
                pathTemplate += '/config/{configCode}';
            }
            const query = opts;
            return this.invokeNoCacheGET(params, pathTemplate, query);
        });
    }
    // get cabin descripions and availability
    cabins(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                cruiseID: opts.cruiseID,
            };
            let pathTemplate = '/cruises/{cruiseID}/cabins';
            if (opts.configCode !== undefined) {
                params.configCode = opts.configCode;
                pathTemplate += '/config/{configCode}';
            }
            const query = (0, lodash_1.omit)(opts, ['cruiseID', 'configCode']);
            return this.invokeNoCacheGET(params, pathTemplate, query);
        });
    }
    cabinUpgrades(agencyId, bookingNumber, cabinNumber, skipCabinsAndPricing = true) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {
                agencyId,
                bookingNumber,
                cabinNumber,
                skipCabinsAndPricing,
            };
            return yield this.unicornClient.cabinUpgrades(params);
        });
    }
    restrictions(cruiseId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.orcaClient.restrictions(cruiseId);
        });
    }
    // get details for a specific cruise
    cruise(id, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { id };
            const pathTemplate = '/cruises/{id}';
            const query = opts;
            return this.invokeShortGET(params, pathTemplate, query);
        });
    }
    // search through all available cruises
    cruises(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/cruises';
            opts.priceModels = getPriceModels(opts.priceModels);
            if (opts.itineraries) {
                opts.itineraries = getItineraries(opts.itineraries);
            }
            return this.invokeShortGET(params, pathTemplate, opts);
        });
    }
    // Parameter onlyNationalities filters countries
    // which are flagged as nationality.
    countries(onlyNationalities) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/countries';
            const query = {};
            if (onlyNationalities) {
                query.nationalities = onlyNationalities;
            }
            return this.invokePermanentGET(params, pathTemplate, query);
        });
    }
    insurances(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/insurances';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    // get flights for a specific cruise
    flights(id, opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { id };
            const pathTemplate = '/cruises/{id}/flights';
            const query = opts;
            return this.invokeShortGET(params, pathTemplate, query);
        });
    }
    flexFlights(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/flexflights';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    railTransport(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/rail';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    searchCruisesGrouped(paxSettings) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/search/cruises';
            const query = {
                minified: true,
            };
            if (paxSettings) {
                query.adults = paxSettings.adults || 0;
                query.juveniles = paxSettings.juveniles || 0;
                query.children = paxSettings.children || 0;
            }
            const result = yield this.invokeShortGET(params, pathTemplate, query);
            if (result.errorMessage) {
                console.log('invalid pax config');
                return [];
            }
            try {
                const transformed = transform(result);
                return transformed;
            }
            catch (err) {
                console.log('unexpected error: ', err);
                return [];
            }
        });
    }
    searchFlightPrices(airportCode) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = `/catalog/bea/${airportCode}`;
            const query = {};
            try {
                const result = yield this.invokeShortGET(params, pathTemplate, query);
                return result;
            }
            catch (err) {
                console.log(err);
                return null;
            }
        });
    }
    searchFileAiports() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/catalog/bea/airports';
            const query = {};
            try {
                const result = yield this.invokeShortGET(params, pathTemplate, query);
                return result;
            }
            catch (err) {
                console.log(err);
                return null;
            }
        });
    }
    searchFileRegions() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/catalog/bea/regions';
            const query = {};
            try {
                const result = yield this.invokeShortGET(params, pathTemplate, query);
                return result;
            }
            catch (err) {
                console.log(err);
                return null;
            }
        });
    }
    searchFileShips() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/catalog/bea/ships';
            const query = {};
            try {
                const result = yield this.invokeShortGET(params, pathTemplate, query);
                return result;
            }
            catch (err) {
                console.log(err);
                return null;
            }
        });
    }
    searchExpinetCatalog() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/catalog/expinet/searchfile';
            const query = {};
            const result = yield this.invokeShortGET(params, pathTemplate, query);
            return result;
        });
    }
    searchExpinetPromoAirports() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/catalog/bea/flexFlights';
            const query = {};
            try {
                const result = yield this.invokeShortGET(params, pathTemplate, query);
                return result;
            }
            catch (error) {
                console.error('error in searchExpinetPromoAirports', error);
                return null;
            }
        });
    }
    exchangeRates() {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/exchangeRates';
            const query = {};
            return this.invokePermanentGET(params, pathTemplate, query);
        });
    }
    stations(name) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { name };
            const pathTemplate = '/rail/stations/{name}';
            return this.invokePermanentGET(params, pathTemplate, {});
        });
    }
    gateways(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/gateways';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    transportations(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/transportations';
            const query = opts;
            return this.invokePermanentGET(params, pathTemplate, query);
        });
    }
    book(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const path = '/book';
            let resp = yield this.invokePOST(params, path, opts);
            const timeout = 3600;
            const that = this;
            let resolved = false;
            const doBooking = () => __awaiter(this, void 0, void 0, function* () {
                do {
                    yield new Promise((resolve) => setTimeout(resolve, 1000));
                    resp = yield that.invokeNoCacheGET({ id: resp.id }, '/book/status/{id}', {});
                } while (resp.status === 'REQUESTED');
                resolved = true;
                return resp;
            });
            return new Promise((resolve, reject) => {
                setTimeout(() => {
                    if (!resolved) {
                        resp.errors = [
                            {
                                code: '402',
                            },
                        ];
                        resp.status = 'ERROR';
                        resolve(resp);
                    }
                }, 120000);
                doBooking().then(resolve).catch(reject);
            });
        });
    }
    calcPricing(opts) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const path = '/book';
            return yield this.invokePOST(params, path, opts);
        });
    }
    confirmationPdf(cruiseID, bookingID, firstName, lastName) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = { bookingID };
            const data = {
                c: cruiseID,
                l: lastName,
                f: firstName,
            };
            const pathTemplate = '/bookings/{bookingID}/confirmation';
            const query = { data: new Buffer(JSON.stringify(data)).toString('base64') };
            const response = yield this.invokePermanentGET(params, pathTemplate, query);
            return response.data;
        });
    }
    bookRail(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/rail/book';
            // wrap because req is an array
            const body = { params: req };
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    pricingWithRail(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/rail/pricing';
            // wrap because req is an array
            const body = { params: req };
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    upgradeCabin(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/cabin/upgrade';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
    pricingWithCabin(req) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = {};
            const pathTemplate = '/cabin/pricing';
            const body = req;
            return this.invokePOST(params, pathTemplate, body);
        });
    }
}
exports.default = IrisClient;
// compatibility fallback
exports.Iris = IrisClient;
//# sourceMappingURL=iris.js.map